export const handleBack = (history, fallbackPath) => {
  if (history.action === "POP") {
    // If the user directly landed on the page (no history), redirect to fallback
    history.push(fallbackPath);
  } else {
    // If there's history, go back
    history.goBack();
  }
};

export const domainRegex =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/)?$/;

export const validateDomain = (domain: string): boolean =>
  domainRegex.test(domain);

export const parseStatusCode = (error: any | null): number | null => {
  if (!error) return null;
  if (error?.response?.status) return error.response.status;
  if (error?.status) return error.status;
  const statusMatch = error.message.match(/API returned error (\d{3})/i);
  return statusMatch ? parseInt(statusMatch[1], 10) : null;
};
